import BoldDecorator from "./bold/viewer.js";
import FontSizeDecorator from "./font-size/viewer.js";
import ItalicDecorator from "./italic/viewer.js";
import StrikethroughDecorator from "./strikethrough/viewer.js";
import SubscriptDecorator from "./subscript/viewer.js";
import SuperscriptDecorator from "./superscript/viewer.js";
import UnderlineDecorator from "./underline/viewer.js";
const nodeViewDecorators = [
  BoldDecorator,
  ItalicDecorator,
  UnderlineDecorator,
  FontSizeDecorator,
  StrikethroughDecorator,
  SubscriptDecorator,
  SuperscriptDecorator
];
export {
  nodeViewDecorators
};
//# sourceMappingURL=viewer.js.map
